"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeApiResponse = exports.isAxiosError = exports.hasRemainingItems = exports.getFileSource = exports.getContentRange = exports.default = void 0;
var _normalizr = require("normalizr");
var _effects = require("redux-saga/effects");
var types = _interopRequireWildcard(require("../resources/entities/types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var getContentRange = headers => {
  var _contentRange$include, _contentRange$include2;
  // headers.content-range looks like this "0 - 50 / 619"

  var contentRange = headers === null || headers === void 0 ? void 0 : headers['content-range'];
  var minRange = 0;
  var maxRange = 0;
  var count = 0;
  if (contentRange !== null && contentRange !== void 0 && (_contentRange$include = contentRange.includes) !== null && _contentRange$include !== void 0 && _contentRange$include.call(contentRange, '-') && contentRange !== null && contentRange !== void 0 && (_contentRange$include2 = contentRange.includes) !== null && _contentRange$include2 !== void 0 && _contentRange$include2.call(contentRange, '/')) {
    var values = contentRange.split('/');
    var currentRange = values[0].trim().split('-');
    minRange = Number(currentRange[0]);
    maxRange = Number(currentRange[1]);
    count = Number(values[1]);
  }
  return {
    minRange,
    maxRange,
    count
  };
};
exports.getContentRange = getContentRange;
var isAxiosError = e => typeof e === 'object' && 'isAxiosError' in e && e.isAxiosError;
exports.isAxiosError = isAxiosError;
var getFileSource = exports.getFileSource = function getFileSource(feedItem, token) {
  var download = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  // if you want to change the expires add expiresIn in the qs
  return {
    uri: "".concat(feedItem.metasFile.uri, "?download=").concat(download ? 'true' : 'false'),
    headers: {
      Authorization: "".concat(token)
    }
  };
};
var hasRemainingItems = response => {
  var {
    maxRange,
    count
  } = getContentRange(response.headers);
  return maxRange !== count;
};
exports.hasRemainingItems = hasRemainingItems;
var normalizeApiResponse = exports.normalizeApiResponse = function* normalizeApiResponse(response, schema, batched) {
  if (!schema) {
    console.error('normalizeApiResponse', {
      response,
      schema,
      batched
    });
  }
  var {
    entities,
    result
  } = (0, _normalizr.normalize)(response, schema);
  var mergeAction = {
    type: types.MERGE_ENTITIES,
    payload: entities
  };
  if (batched) {
    return {
      result,
      batchedAction: mergeAction
    };
  }
  yield (0, _effects.put)(mergeAction);
  return result;
};
var _default = exports.default = {
  getContentRange,
  getFileSource,
  hasRemainingItems,
  normalizeApiResponse
};